const DEFAULT_HOST = "https://florapoint.su";
const LEGACY_FILE_HOSTS = ["https://florapoint.tech", "https://florapoint.su"];

export const FILES_HOST = process.env.REACT_APP_FILES_HOST || DEFAULT_HOST;

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || `${DEFAULT_HOST}/api.admin/`;

const normalizeAbsoluteUrl = (url) => {
  let result = url;
  for (const legacyHost of LEGACY_FILE_HOSTS) {
    if (legacyHost !== FILES_HOST) {
      result = result.replace(legacyHost, FILES_HOST);
    }
  }
  return result;
};

/** Абсолютный URL файла (шаблоны, Excel и т.д.) */
export const resolveFileUrl = (fileUrl) => {
  if (!fileUrl) return "";
  if (/^https?:\/\//i.test(fileUrl)) {
    return normalizeAbsoluteUrl(fileUrl);
  }
  return `${FILES_HOST}${fileUrl.startsWith("/") ? "" : "/"}${fileUrl}`;
};

/** Абсолютный URL картинки товара */
export const resolveImageUrl = (link) => {
  if (!link) return "";
  if (/^https?:\/\//i.test(link)) {
    return normalizeAbsoluteUrl(link);
  }
  return `${FILES_HOST}${link.startsWith("/") ? "" : "/"}${link}`;
};
